// John Eldhose 20190503
import { RestfulPost } from './Restful';

export async function renewProduct(sn) {
  const cache = await RestfulPost('renewProduct', {sn: sn}, (response) => {
      return response['data'];
    }, (error) => {
      console.log(error);
      return false;
    }
  );
  return cache;
}



// WEBPACK FOOTER //
// ./src/Api/renewProduct.js